import type { Action } from 'react-sweet-state';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';
import { PACKAGE_NAME, NONE, TEAM_NAME } from '../../../../common/constants';
import { STEPS } from '../../constants';
import type { YourWorkTourState, ActionProps } from '../../types';
import { end } from '../end';

export type Next = (triggerName: string, analyticsEvent: UIAnalyticsEvent) => void;

export const next =
	(actionProps: ActionProps): Action<YourWorkTourState> =>
	({ getState, setState, dispatch }) =>
	// @ts-expect-error - TS2322 - Type '(triggerName: string, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to type 'void | Promise<void>'.
	(triggerName: string, analyticsEvent: UIAnalyticsEvent) => {
		const { currentStep } = getState();
		const stepIndex = STEPS.findIndex((element) => element === currentStep);

		if (stepIndex === -1) {
			const error = new Error('Tried to go next but could not find a step');
			fireErrorAnalytics({
				error,
				meta: {
					id: 'yourWorkTourNext_stepIndexMinusOne',
					packageName: PACKAGE_NAME,
					teamName: TEAM_NAME,
				},
				attributes: {
					message: error.message,
				},
				sendToPrivacyUnsafeSplunk: true,
			});
			throw error;
		}

		const isNextStepNone = stepIndex + 1 >= STEPS.indexOf(NONE);
		if (isNextStepNone) {
			// call end action, to set the correct step, and to call CoordinationClient stop
			// @ts-expect-error - TS2349 - This expression is not callable.
			dispatch(end(actionProps))(triggerName, analyticsEvent);
		} else {
			// just advance the step
			setState({ currentStep: STEPS[stepIndex + 1] });
		}
	};
